import { render, staticRenderFns } from "./OriginalVoucherList.vue?vue&type=template&id=5186eed1&scoped=true"
import script from "./OriginalVoucherList.vue?vue&type=script&lang=js"
export * from "./OriginalVoucherList.vue?vue&type=script&lang=js"
import style0 from "./OriginalVoucherList.vue?vue&type=style&index=0&id=5186eed1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5186eed1",
  null
  
)

export default component.exports